<template>
    <div>
        <div class="col-md-12">
            <h3>Relatório Analítico campanha</h3>
            <table id="relLog" ref='tabela' class="table display table-hover table-striped" style="width: 100%">
                <thead></thead>
                <tbody></tbody>
                <tfoot></tfoot>
            </table>
        </div>
    </div>
</template>

<script>

import validarTel from '../../store/modules/validarTel';
export default {
    props: {
        filter: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            dt: null,
            val: this.filter
        }
    },
    watch: {
        filter: {
            handler: function () {
                this.createTable()
            },
            deep: true
        }
    },
    methods: {
        createTable() {
            if (this.dt) {
                $('#relLog').DataTable().destroy();
            }

            this.dt = $('#relLog').DataTable({
                ajax: {
                    url: '/marketing/log',
                    data: { param: this.filter },
                    dataSrc: ''
                },
                columns: [
                    {
                        data: 'created_at',
                        class: 'text-center align-middle',
                        title: 'Data',
                        render: (data) => data ? moment(data).format('DD/MM/YYYY HH:mm:ss') : ''
                    },
                    {
                        data: 'nome_campanha',
                        class: 'text-center align-middle',
                        title: 'Campanha'
                    },
                    {
                        data: 'telefone',
                        class: 'text-center align-middle',
                        title: 'Telefone',
                        render: (data) => validarTel.formata_telefone(data)
                    },
                    {
                        data: 'name',
                        class: 'text-center align-middle',
                        title: 'Cliente'
                    },
                    {
                        data: 'status',
                        class: 'text-center align-middle',
                        title: 'Status'
                    }]
            });
            this.dt.buttons('.dtUpdateButton').remove();
        }
    },
    mounted() {
        this.createTable();
    }
}
</script>
